export type { FetchCategoriesSuccess, FetchCategoriesFailure } from './kb-category';
export {
	NOT_SUPPORTED,
	FETCH_CATEGORIES_SUCCESS,
	FETCH_CATEGORIES_FAILURE,
	fetchCategoriesSuccess,
	fetchCategoriesFailure,
} from './kb-category';
